export function encodeBase64Json(value) {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
}

export function getDaypartFilter(daypart) {
  const timePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!daypart.braKey || !timePattern.test(daypart.startTime) ||
      !timePattern.test(daypart.endTime) || daypart.startTime === daypart.endTime) {
    throw new Error("Select a daypart with valid start and end times.");
  }
  return {
    braKey: daypart.braKey,
    startTime: daypart.startTime,
    endTime: daypart.endTime,
    timeZone: daypart.timeZone || "Asia/Qatar",
  };
}

function normalizeDaypartOutlet(outlet, selectedDaypart) {
  const dayparts = outlet.dayparts.filter((part) => !selectedDaypart || (
    String(outlet.braKey) === String(selectedDaypart.braKey) &&
    (selectedDaypart.id && part.daypartId != null
      ? String(part.daypartId) === String(selectedDaypart.id)
      : part.startTime === selectedDaypart.startTime && part.endTime === selectedDaypart.endTime)
  ));
  return {
    ...outlet,
    dayparts,
    items: dayparts.flatMap((part) => (part.items || []).map((item) => ({
      ...item,
      daypartId: part.daypartId,
      daypartType: part.type,
    }))),
    totals: dayparts.reduce((totals, part) => ({
      quantity: totals.quantity + (part.totals?.quantity || 0),
      sales: totals.sales + (part.totals?.sales || 0),
      cost: totals.cost + (part.totals?.cost || 0),
      profit: totals.profit + (part.totals?.profit || 0),
    }), { quantity: 0, sales: 0, cost: 0, profit: 0 }),
    rules: dayparts.length === 1 ? dayparts[0].rules : undefined,
  };
}

export async function getMenuReport({
  apiBaseUrl,
  usrKey,
  reportType, // "menu-engineering" or "by-item-ranked"
  chaKeys,
  startDate,
  endDate,
  categoryNo,
  itemRefs,
  revCent,
  daypart,
}) {
  const filter = {
    chaKey: chaKeys,
    date: {
      $gte: Math.floor(startDate.getTime() / 1000),
      $lte: Math.floor(endDate.getTime() / 1000),
    },
    ...(categoryNo != null && { categoryNo }),
    ...(itemRefs?.length && { itemRefs }),
    ...(revCent?.length && { revCent }),
    ...(daypart && { daypart: getDaypartFilter(daypart) }),
  };

  const endpoint = reportType === "menu-engineering" ? "menu-engineering-by-daypart" : reportType;
  const response = await fetch(`${apiBaseUrl}/${endpoint}`, {
    method: "POST",
    headers: {
      Authorization: usrKey,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ base64filter: encodeBase64Json(filter) }),
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.error || `Menu report failed (${response.status})`);
  }

  return reportType === "menu-engineering" && Array.isArray(result.outlets)
    ? result.outlets.map((outlet) => Array.isArray(outlet.dayparts)
      ? normalizeDaypartOutlet(outlet, daypart)
      : outlet)
    : result.outlets;
}
